import api from '@/services/api';

export default {
  async getDropdown(includePropertyGroups) {
    try {
      let response = await api.get(`Properties/Dropdown?includePropertyGroups=${includePropertyGroups || false}`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async getFullyDefinedFiscalYears(propertyId, withBudget) {
    try {
      let response = await api.get(`Properties/FullyDefinedFiscalYears?propertyId=${propertyId}&withBudget=${withBudget || false}`);
      if (response && response.status == 200 && response.data) {        
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async getPropertyFiscalYearStartMonth(propertyId) {
    try {
      let response = await api.get(`Properties/${propertyId}/FiscalYearStartMonth`);
      if (response && response.status == 200 && response.data) {        
        return response.data;
      }
      return 1;
    } catch (ex) {
      console.error(ex);
      return 1;
    } 
  },
  async getManagementFees(propertyId, budgetIterationId) {
    try {
      let url = `Properties/${propertyId}/ManagementFees?budgetIterationId=${budgetIterationId}`;
      let response = await api.get(url);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return 1;
    } catch (ex) {
      console.error(ex);
      return 1;
    } 
  }
}
